import { render } from "./Gamification.vue?vue&type=template&id=26bcf893&scoped=true"
import script from "./Gamification.vue?vue&type=script&lang=js"
export * from "./Gamification.vue?vue&type=script&lang=js"

import "./Gamification.vue?vue&type=style&index=0&id=26bcf893&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bcf893"]])

export default __exports__